import React from "react";
import { Card, CardContent, Typography, Avatar, Divider, Box, Chip } from "@mui/material";
import { API_BASE_URL } from "../../../utils/api";
import ArchitecturalRequestTimeline from "../ArchitecturalRequestTimeline";

const MemberCard = ({ member, id }) => {
  if (!member) return null;

  return (
    <Card>
      <CardContent sx={{ textAlign: "center" }}>
        <Avatar
          src={`${API_BASE_URL}/images/${encodeURIComponent(member.PhotoGraphicFileName?.trim() || "")}`}
          alt={member.FirstName}
          sx={{ width: 120, height: 120, margin: "0 auto", marginBottom: 2 }}
        />
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          {`${member.FirstName} ${member.LastName}`}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Member Code: {member.ClubMemberCode}
        </Typography>
        <Divider sx={{ marginY: 2 }} />
        <Typography variant="body2"><strong>Gender:</strong> {member.Gender}</Typography>
        <Typography variant="body2"><strong>Birth Date:</strong> {new Date(member.BirthDate).toLocaleDateString()}</Typography>
        <Typography variant="body2"><strong>Join Date:</strong> {new Date(member.JoinDate).toLocaleDateString()}</Typography>
        <Typography variant="body2"><strong>Status:</strong> <Chip label={member.ClubStatusRuleCode} color="success" size="small" /></Typography>
        <Typography variant="body2"><strong>Address:</strong> {member.FullAddress || "N/A"}</Typography>
        <Divider sx={{ marginY: 2 }} />
        <Box>
          <ArchitecturalRequestTimeline architectural_request_id={id} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default MemberCard;
